import Vue from 'vue'
import proto from "../../protocol"

import {
    CONTENT_MANAGER,
    CHATS,
    NOTIFICATIONS,
    CONTACTS,
    LOGIN,
    INFO,
    NOTIFICATIONS_NEW,
    TASKS,
} from '../modulesNames'

import {
    GET_MAIN_TYPE,
    GET_CHAT_SCROLL_UP,
    GET_THREADS_SCROLL_UP,
    GET_CHAT,
    IS_OWN_CHAT,
    IS_NOTE_CHAT,
    GET_CHAT_EDIT_MESSAGE_ID,
    GET_CHAT_REPLY_MESSAGE_ID,
    GET_CHAT_REPLY_QUOTE,
    GET_CHAT_SELECTED_MSG_ENTITIES,
    GET_CHAT_SEARCH_STRING,
    GET_CHAT_MEDIA_SEARCH_STRING,
    GET_CHAT_ITEM_TEXT,
    GET_MERGED_CONTACT_BY_ID,
    GET_SELECT_MODE,
    GET_SELECTED_MSGS,
    GET_MESSAGE_BY_ID,
    GET_CHAT_MESSAGES,
    GET_CHAT_SCH_MESSAGE_BY_ID,
    GET_CHAT_SCH_MESSAGES,
    GET_REACTIONS_PANEL,
    GET_REACTIONS_PICKER,
    GET_CHAT_LAST_MESSAGE,
    GET_SERVER_API,
    IS_CHAT_HAVE_LAST_MESSAGE,
    IS_CHAT_NEW_API_SUPPORTED,
    GET_CURRENT_COMMENTS,
    GET_COMMENT_BY_ID,
    GET_COMMENT_ID,
    GET_DOCUMENT_HIDDEN,
    GET_DOCUMENT_FOCUS,
    GET_INFO_SHOW_SEARCH,
    GET_CHAT_SAVED_DATA,
    GET_CHAT_LINK,
} from '../gettersTypes'

import {
    ACT_OPEN_CHAT,
    ACT_CHAT_SCROLL_UP,
    ACT_THREADS_SCROLL_UP,
    ACT_CHAT_UPDATE_EDITED,
    ACT_CHAT_UPDATE_REPLY,
    ACT_CHAT_REMOVE_MSG,
    ACT_CHAT_REMOVE_MSGS,
    ACT_CHAT_CHANGE_MSG_TEXT,
    ACT_CHAT_GET_MESSAGE_BY_ID,
    ACT_SET_CHAT_DRAFT,
    ACT_CHAT_SET_MSG_ENTITIES,
    ACT_CHAT_SET_SEARCH,
    ACT_CHAT_SET_MEDIA_SEARCH,
    ACT_OPEN_CUSTOM_NOTIFICATION,
    ACT_SET_CHAT_MARKED,
    ACT_CHAT_ADD_MESSAGE,
    ACT_CHAT_UPDATE_MESSAGE,
    ACT_CHAT_UPD_MESSAGE,
    ACT_CHAT_SET_MSG_REACTION,
    ACT_CHAT_UPDATE_REACTION,
    ACT_CHAT_SHOW_REACTION_PANEL,
    ACT_CHAT_SHOW_REACTION_PICKER,
    ACT_UPDATE_SEARCHED_CONTACT,
    ACT_SET_SELECT_MODE,
    ACT_SET_SELECTED_MSGS,
    ACT_DELETE_SELECTED_MSGS,
    ACT_CHAT_GET_MESSAGES,
    ACT_CHAT_SEARCH_MESSAGES,
    ACT_CHAT_GET_PUBLICATIONS_MEDIA,
    ACT_CHAT_GET_SCREEN_MESSAGES,
    ACT_CHAT_GET_PREV_MESSAGES,
    ACT_CHAT_GET_NEXT_MESSAGES,
    ACT_CHAT_LOAD_PREV_MESSAGES,
    ACT_CHAT_LOAD_NEXT_MESSAGES,
    ACT_CHAT_UPDATE_MESSAGES,
    ACT_SET_MSG_COMMENT_SUBSCRIBED,
    ACT_COMMENT_SUBSCRIBED,
    ACT_COMMENT_SENT_RECEIVED,
    ACT_COMMENT_REACTION,
    ACT_COMMENT_UPDATE,
    ACT_COMMENT_CHANGE,
    ACT_SET_CURRENT_COMMENTS,
    ACT_INFO_CHANGE_PARAMS,
    ACT_INFO_SET_SHOW_SEARCH,
    ACT_CHAT_SEARCH_GLOBAL,
    ACT_NOTIFY_NEW_ADD,
    ACT_CHAT_MERGE_UNSENT_MESSAGES,
    ACT_CHAT_UPDATE_UNSENT_MESSAGE,
    ACT_JOIN_CHAT_BY_LINK,
    ACT_CHAT_LINK_INFO,
    ACT_CHAT_LINK_UPDATE,
    ACT_CHAT_LINK_DELETE,
    ACT_CHAT_GET_SCH_MESSAGES,
    ACT_CHAT_ADD_SCH_MESSAGE,
    ACT_CHAT_ADD_UNSENT_SCH_MESSAGE,
    ACT_CHAT_DELETE_UNSENT_SCH_MESSAGE,
    ACT_CHAT_UPDATE_SCH_MESSAGE,
    ACT_CHAT_DELETE_SCH_MESSAGE,
    ACT_CHAT_SCH_MESSAGE_CHANGE,
    ACT_TASKS_GET_TASKS,
    ACT_TASKS_ADD_TASK,
    ACT_TASKS_UPDATE_TASK,
    ACT_TASKS_DELETE_TASKS,
    ACT_SAVE_CHAT_DATA,
} from '../actionsTypes'

import {
    MUT_CHAT_UPDATE_MESSAGE,
    MUT_CHAT_SORT_MESSAGES,
    MUT_SELECTED_MESSAGE,
    MUT_CHAT_SCROLL_UP,
    MUT_THREADS_SCROLL_UP,
    MUT_SET_MSG_ENTITIES,
    MUT_CHAT_SET_SEARCH,
    MUT_CHAT_SET_MEDIA_SEARCH,
    MUT_SET_SELECT_MODE,
    MUT_SET_SELECTED_MSGS,
    MUT_DELETE_SELECTED_MSGS,
    MUT_UPDATE_MESSAGE_REACTION,
    MUT_SHOW_REACTION_PANEL,
    MUT_SHOW_REACTION_PICKER,
    MUT_SET_CURRENT_COMMENTS,
    MUT_SET_COMMENT_ID,
    MUT_COMMENT_DELETE,
    MUT_UPDATE_COMMON_MSG_COMMENT_COUNT,
    MUT_CHAT_UPDATE_UNSENT_MESSAGE,
    MUT_CHAT_LINK_UPDATE,
    MUT_CHAT_SCH_MESSAGES_SORT,
    MUT_CHAT_SCH_MESSAGES,
    MUT_CHAT_ADD_UNSENT_SCH_MESSAGE,
    MUT_CHAT_SCH_MESSAGE_CHANGE,
    MUT_DELETE_UNSENT_SCH_MSG_CHAT_DATA,
} from '../mutationsTypes'

import { CONTACT_FIELD_TYPES, SELECTED_MSG_TYPES, LOCAL_SAVED_DATA_KEYS } from '../../constants'
import { msgStatuses as MSG_STATUSES } from '../../declarations'
import moment from 'moment'
import {i18n} from '../../../ext/i18n'
import { CHAT_MAIN_TYPES } from './content-manager'
import { getIsFullCompactMode, setFullCompactVisibility } from '../../../ext/trackResizes';
import { NOTIFY_DATA_TYPES } from './notificationsNew'

import { equals, tryCatch } from 'ramda'

import { taskType, taskChangesType } from '../../declarations'

const locale = i18n.messages[i18n.locale]

function isSameChat(chatObj, msgObj) {
    return chatObj.cid === msgObj.cid && chatObj.cidType === msgObj.cidType
}

function getMessageById(messages, message_id){
    return messages.find(message => {
        return message.id === message_id || message.localId === message_id
    })
}

export function convertTimeMsg(msg) {
    let time = {}
    if('time' in msg && typeof msg.time === 'number') {
        time.sentDate = moment().subtract(msg.time, 'seconds').format('DD.MM.YYYY')
        time.sentTime = moment().subtract(msg.time, 'seconds').format('HH:mm')
        time.fullTime = moment().subtract(msg.time, 'seconds').format('YYYY-MM-DD HH:mm:ss')
    }
    if('receivedTime' in msg && typeof msg.receivedTime === 'number') {
        time.receivedDate = moment().subtract(msg.receivedTime, 'seconds').format('DD.MM.YYYY')
        time.receivedTime = moment().subtract(msg.receivedTime, 'seconds').format('HH:mm')
    }
    if('watchedTime' in msg && typeof msg.watchedTime === 'number') {
        time.watchedDate = moment().subtract(msg.watchedTime, 'seconds').format('DD.MM.YYYY')
        time.watchedTime = moment().subtract(msg.watchedTime, 'seconds').format('HH:mm')
    }
    if('editedTime' in msg && typeof msg.editedTime === 'number') {
        time.editedDate = moment().subtract(msg.editedTime, 'seconds').format('DD.MM.YYYY')
        time.editedTime = moment().subtract(msg.editedTime, 'seconds').format('HH:mm')
    }
    return time
}

const convertUnsentMsgTime = (fullDate) => {
    const currentUnixTime = moment().unix()
    const fullDateUnix = moment(fullDate, 'YYYY-MM-DD HH:mm:ss').unix()
    const delta = currentUnixTime - fullDateUnix
    return delta
}

const state = {
    cid: null,
    cidType: null,
    messages: [],
    selectedMsg: null,
    selectedMsgEntities: {},
    poll: {},
    pollVotes: [],
    isUpdating: false,
    isScrolling: false,
    scroll_up: false,
    threads_scroll_up: false,
    chatSearchString: null,
    mediaSearchString: null,
    isSelectMode: false,
    selectedMessages: [],
    reactionsPanel: {
        isPanelShow: false,
        reactions: {},
        panelStyle: {}
    },
    reactionsPicker: {
        isPickerShow: false,
        msgId: null,
        pickerStyle: {}
    },
    msgsLoadStepSize: 50,
    maxMsgs: 100,
    prevFirstMsg: 0,
    prevLastMsg: 0,
    comments: [],
    commentId: 0,
    groupChatLinks: {},
    schMessages: [],
}

const getters = {
    isUpdating(state) {
        return state.isUpdating
    },
    isScrolling(state) {
        return state.isScrolling
    },
    [GET_CHAT_MESSAGES](state) {
        if (state.messages.length > state.maxMsgs) {
            return state.messages.slice(0, state.maxMsgs)
        } else {
            return state.messages
        }
    },
    [GET_CHAT_SCH_MESSAGES]: (state) => (cid) => {
        if (!cid) return []
        const filteredSchMsgs = state.schMessages.filter(m => {
            return m && m.payload && m.payload.data && m.payload.data.cid === cid
        })
        return filteredSchMsgs || []
    },
    [GET_CHAT_SCH_MESSAGE_BY_ID]: (state) => (taskId) => {
        if (!taskId) return null
        return state.schMessages.find(m => m && m.taskId && m.taskId === taskId) || null
    },
    getMaxSchMessagesId(state) {
        return Math.max(...state.schMessages.map(m => m.taskId))
    },
    [GET_MESSAGE_BY_ID](state) {
        return function (message_id) {
            return getMessageById(state.messages, message_id)
        }
    },
    [GET_CHAT_REPLY_QUOTE](state) {
        return state.selectedMsg && state.selectedMsg.quote
    },
    [GET_CHAT_REPLY_MESSAGE_ID]: (state) => (isComments = false) => {
        const selectedMsg = state.selectedMsg && state.selectedMsg.type === SELECTED_MSG_TYPES.REPLY && state.selectedMsg
        return selectedMsg && selectedMsg.isThreads === isComments && selectedMsg.id
    },
    [GET_CHAT_EDIT_MESSAGE_ID]: (state) => (isComments = false) => {
        const selectedMsg = state.selectedMsg && state.selectedMsg.type === SELECTED_MSG_TYPES.EDITED && state.selectedMsg
        return selectedMsg && selectedMsg.isThreads === isComments && selectedMsg.id
    },
    getPollVoteById(state) {
        return function (id) {
            let result = false;
            state.pollVotes.forEach(function(item) {
                if(item === id) result = true;
            });
            return result;
        };
    },
    [GET_CHAT_SCROLL_UP](state) {
        return state.scroll_up
    },
    [GET_THREADS_SCROLL_UP](state) {
        return state.threads_scroll_up
    },
    [IS_CHAT_HAVE_LAST_MESSAGE](state, getters, rootState, rootGetters) {
        const chatMessages = getters[GET_CHAT_MESSAGES]
        const chatLastMessage = chatMessages[chatMessages.length - 1]
        if (!chatLastMessage) return false
        const lastMessageInChats = rootGetters[`${CHATS}/${GET_CHAT_LAST_MESSAGE}`]({
            cid: state.cid,
            cidType: state.cidType,
        })
        if (!lastMessageInChats) return false
        return chatLastMessage.id === lastMessageInChats.id
    },
    [IS_CHAT_NEW_API_SUPPORTED](state, getters, rootState, rootGetters) {
        return rootGetters[`${LOGIN}/${GET_SERVER_API}`] >= declarations.serverAPILevels.LEVEL_16
    },
    [GET_CHAT_SELECTED_MSG_ENTITIES](state) {
        return state.selectedMsgEntities
    },
    [GET_CHAT_SEARCH_STRING](state) {
        return state.chatSearchString
    },
    [GET_CHAT_MEDIA_SEARCH_STRING](state) {
        return state.mediaSearchString
    },
    [GET_CHAT_ITEM_TEXT]: (state, getters, rootState, rootGetters) => ({message, list = false}) => {
        let text
        switch (message.dataType) {
            case declarations.msgDataTypes.MSG_DATA_TYPE_TEXT:
                text = message.data
                break
            case declarations.msgDataTypes.MSG_DATA_TYPE_DATA:
                if (message.data.pollId) message.data.type = 'poll'
                if (message.type === 'out' && message.status === MSG_STATUSES.MSG_STATUS_SENDING) {
                    const _data = message.data && message.data.type ? message.data : JSON.parse(message.data)
                    if (_data.type === declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_TEXT) text = _data.text
                } else {
                    let _data = message.data
                    try {
                        if (message.hasOwnProperty('localId')) {
                            if (!message.time && message.timeDetails) {
                                message.time = convertUnsentMsgTime(message.timeDetails.fullTime)
                            }
                            if (!message.data.type) {
                                _data = JSON.parse(message.data)
                            }
                        }
                        text = list ? getListDataText(message.data) : getDataText({ state, getters, rootState, rootGetters }, _data)
                    } catch (error) {
                        console.log("🚀 ~ chat.js:330 ~ error:", error)
                    }
                }
                break
            case declarations.msgDataTypes.MSG_DATA_TYPE_UNSTORED:
                text = message.data
                break
            case declarations.msgDataTypes.MSG_DATA_TYPE_SYSTEM:
                text = getSystemText({state, getters, rootState, rootGetters}, message.data, )
                break
            default:
                text = locale['unknown-data-type']
        }
        return text
    },
    [GET_SELECT_MODE]: (state) => state.isSelectMode,   
    [GET_SELECTED_MSGS]: (state) => state.selectedMessages,
    [GET_REACTIONS_PANEL]: (state) => state.reactionsPanel,
    [GET_REACTIONS_PICKER]: (state) => state.reactionsPicker,
    [GET_CURRENT_COMMENTS](state) {
        if (state.comments.length > state.maxMsgs) {
            return state.comments.slice(0, state.maxMsgs)
        } else {
            return state.comments
        }
    },
    [GET_COMMENT_ID]: (state) => state.commentId,
    [GET_COMMENT_BY_ID]: (state) => (id) => {
        return getMessageById(state.comments, id)
    },
    [GET_CHAT_LINK]: (state) => (cid) => {
        return state.groupChatLinks[cid] && state.groupChatLinks[cid][0] && state.groupChatLinks[cid][0].link || null
    },
}

const actions = {
    async update ({state, dispatch, commit, rootGetters}, params) {
        let { cid = state.cid, cidType = state.cidType, non_clear } = params
        if (!params.cid) params.cid = cid
        if (!params.cidType) params.cidType = cidType
        let noLoad = rootGetters[`${CHATS}/${IS_OWN_CHAT}`](params) && !rootGetters[`${CHATS}/${IS_NOTE_CHAT}`](params)
        let messages = noLoad ? [] : await proto.getMessages(params)
        if (!non_clear) commit('clearMessages', { isComments: false })
        messages.forEach((message) => dispatch(ACT_CHAT_UPDATE_MESSAGE, {
            cid,
            cidType,
            message,
        }))

        if (messages && messages.length) {
            commit(MUT_CHAT_SORT_MESSAGES)
            return state.messages
        }
    },
    async [ACT_CHAT_GET_SCREEN_MESSAGES]({state, dispatch, commit, getters, rootGetters}, params = {}) {
        let { id, commentId = 0 } = params
        let state_msgs = commentId ? state.comments : state.messages
        let messages = []
        const chat = {cid: state.cid, cidType: state.cidType}
        if (commentId) chat.commentId = commentId
        const load = !rootGetters[`${CHATS}/${IS_OWN_CHAT}`](chat) || rootGetters[`${CHATS}/${IS_NOTE_CHAT}`](chat)
        if (load) {
            if (id) {
                if (getters[IS_CHAT_NEW_API_SUPPORTED]) {
                    messages = messages.concat(await dispatch(ACT_CHAT_LOAD_PREV_MESSAGES, {id: id + 1, commentId, count: 20}))
                    messages = messages.concat(await dispatch(ACT_CHAT_LOAD_NEXT_MESSAGES, {id, commentId, count: state.msgsLoadStepSize}))
                } else {
                    messages = await dispatch(ACT_CHAT_GET_MESSAGES, { // грузим с id
                        ...chat,
                        minId: id,
                        commentId
                    })
                    let prevMessages = await dispatch(ACT_CHAT_LOAD_PREV_MESSAGES, { // догружаем предшествующие сообщения
                        id: Math.max(id - 1, 1),
                        count: 20,
                        commentId
                    })
                    messages = prevMessages.concat(messages)
                }
            } else {
                messages.push(...await dispatch(ACT_CHAT_GET_MESSAGES, {...chat, count: state.msgsLoadStepSize, commentId}))
            }
        }
        const isComments = !!commentId
        commit('clearMessages', {isComments})
        await dispatch(ACT_CHAT_UPDATE_MESSAGES, {messages, commentId})
        return state_msgs
    },
    async [ACT_CHAT_GET_PREV_MESSAGES]({state, dispatch}, params = {}) {
        let { commentId } = params
        let state_msgs = commentId ? state.comments : state.messages
        let cur_first_index = 0
        let firstMessage = state_msgs[cur_first_index] //.slice(0, 1).pop()
        // console.log("🚀 ~ _chat.js:410 ~ firstMessage:", firstMessage)
        let firstId = firstMessage && firstMessage.id || 0
        if (firstId < 0 && msgs_len > 1) {
            while (firstMessage && firstId < 0) {
                cur_first_index++
                firstMessage = state_msgs[cur_first_index]
                firstId = firstMessage && firstMessage.id || 0
            }
        }
        if (!firstId || firstId < 0 || state.prevFirstMsg === firstId) {
            return
        }
        state.prevFirstMsg = firstId
        // console.log("🚀 ~ _chat.js:393 ~ firstId:", firstId)
        state.prevLastMsg = 0
        let messages = await dispatch(ACT_CHAT_LOAD_PREV_MESSAGES, { id: firstId, commentId, count: state.msgsLoadStepSize })
        // console.log("🚀 ~ _chat.js:428 ~ messages:", messages)
        // console.log("🚀 ~ _chat.js:397 ~ commentId:", commentId)
        if (messages && messages.length) dispatch(ACT_CHAT_UPDATE_MESSAGES, {prev: true, messages, commentId})
    },
    async [ACT_CHAT_GET_NEXT_MESSAGES]({state, dispatch, getters}, params = {}) {
        if (!Object.keys(params)) return
        let { commentId } = params
        let state_msgs = commentId ? state.comments : state.messages

        if (getters[IS_CHAT_NEW_API_SUPPORTED]) {
            const msgs_len = state_msgs.length
            let lastMessage = state_msgs[msgs_len - 1] //.slice(-1).pop()
            let lastId = lastMessage && lastMessage.id || 0
            if (lastId < 0 && msgs_len > 1) {
                let cur_len = msgs_len - 1
                while (lastMessage && lastId < 0) {
                    cur_len--
                    lastMessage = state_msgs[cur_len]
                    lastId = lastMessage && lastMessage.id || 0
                }
                // //console.log("🚀 ~ chat.js:448 ~ lastMessage:", lastMessage)
            }
            if (!lastId || lastId < 0 || state.prevLastMsg === lastId) {
                // //console.log("🚀 ~ chat.js:451 ~ lastId:", lastId)
                return
            }
            // console.log("🚀  ~ chat.js:429 ~ lastId:", lastId)
            state.prevLastMsg = lastId
            state.prevFirstMsg = 0
            let messages = await dispatch(ACT_CHAT_LOAD_NEXT_MESSAGES, {id: lastId, commentId, count: state.msgsLoadStepSize})
            if (messages && messages.length) dispatch(ACT_CHAT_UPDATE_MESSAGES, { next: true, messages, commentId })
        } else {
            if (state_msgs.length > state.maxMsgs) {
                state_msgs.splice(0, state.msgsLoadStepSize)
            }
        }
    },
    async [ACT_CHAT_LOAD_PREV_MESSAGES]({dispatch}, {id, count, commentId}) {
        let params = {
            cid: state.cid,
            cidType: state.cidType,
            startId: Math.floor(--id),
            count
        }
        if (commentId) params.commentId = commentId
        const msgs = await dispatch(ACT_CHAT_GET_MESSAGES, params)
        return msgs
    },
    async [ACT_CHAT_LOAD_NEXT_MESSAGES]({dispatch}, {id, count, commentId}) {
        let params = {
            cid: state.cid,
            cidType: state.cidType,
            startId: Math.floor(++id),
            scrollDown: true,
            count,
        }
        if (commentId) params.commentId = commentId
        const msgs = await dispatch(ACT_CHAT_GET_MESSAGES, params)
        return msgs
    },
    async [ACT_CHAT_UPDATE_MESSAGES]({state, dispatch, commit, getters}, { prev = false, next = false, messages, commentId }) {
        let state_msgs = commentId ? state.comments : state.messages
        const cid = state.cid, cidType = state.cidType
        const chat = { cid, cidType }
        if (commentId) chat.commentId = commentId
        const newMsgsCount = messages.length
        if (getters[IS_CHAT_NEW_API_SUPPORTED]) {
            if (prev) {
                while (state_msgs.length + newMsgsCount > state.maxMsgs) {
                    state_msgs.pop()
                }
            }
            if (next) {
                while (state_msgs.length + newMsgsCount > state.maxMsgs) {
                    state_msgs.shift()
                }
            }
        }
        await dispatch(ACT_CHAT_MERGE_UNSENT_MESSAGES, { cid, cidType })
        messages.forEach((message) => dispatch(ACT_CHAT_UPDATE_MESSAGE, { ...chat, message }))
        commit(MUT_CHAT_SORT_MESSAGES, {commentId})
    },
    async [ACT_CHAT_GET_MESSAGES]({}, params) {
        return proto.getMessages(params)
    },
    async [ACT_CHAT_GET_SCH_MESSAGES]({ dispatch, commit, rootGetters }, { taskPayload }) {
        const schMsgs = await dispatch(`${TASKS}/${ACT_TASKS_GET_TASKS}`, taskPayload, { root: true })
        // const _schMsgsTest = JSON.parse(JSON.stringify(schMsgs))
        // console.log("🚀 ~ chat.js:539 ~ _schMsgsTest:", _schMsgsTest)
        const { cid, cidType } = taskPayload && taskPayload.data || {}
        const key = LOCAL_SAVED_DATA_KEYS.SCH_MSGS_UNSENT
        const savedData = rootGetters[`${CHATS}/${GET_CHAT_SAVED_DATA}`]({ cid, cidType, key })
        const savedSchMsgs = savedData && savedData.map(sd => {
            const retSchMsg = {
                taskId: sd.taskId,
                type: taskType.ACTION,
                time: sd.time,
                status: MSG_STATUSES.MSG_STATUS_SEND_ERROR,
                payload: {
                    data: sd.data,
                    type: sd.type
                }
            }
            return retSchMsg
        }) || []
        const mergedSchMsgs = [...schMsgs, ...savedSchMsgs]
        commit(MUT_CHAT_SCH_MESSAGES, mergedSchMsgs)
        commit(MUT_CHAT_SCH_MESSAGES_SORT)
    },
    async [ACT_CHAT_ADD_SCH_MESSAGE]({ dispatch, getters }, { cid, cidType, time, ...payload}) {
        const localId = getters['getMaxSchMessagesId'] + 0.01
        try {
            console.log("🚀 ~ chat.js:561 ~ payload:", payload)
            payload.taskPayload.data.localId = localId
            const taskId = await dispatch(`${TASKS}/${ACT_TASKS_ADD_TASK}`, { time, ...payload }, { root: true })
            return taskId
        } catch (error) {
            // console.log("🚀 ~ chat.js:554 ~ error:", error)
            // const key = LOCAL_SAVED_DATA_KEYS.SCH_MSGS_DRAFT
            const key = LOCAL_SAVED_DATA_KEYS.SCH_MSGS_UNSENT
            const _payload = { key }
            // _payload[key] = inputText
            const taskId = localId //getters['getMaxSchMessagesId'] + 0.01
            // console.log("🚀 ~ chat.js:553 ~ taskId:", taskId)
            _payload[key] = { type: taskType.ACTION, taskId, time, ...payload.taskPayload }
            _payload.cid = cid
            _payload.cidType = cidType
            dispatch(`${CHATS}/${ACT_SAVE_CHAT_DATA}`, _payload, { root: true })
            dispatch(ACT_CHAT_ADD_UNSENT_SCH_MESSAGE, { taskId, time, type: taskType.ACTION, taskPayload: payload.taskPayload })
            return 0
        }
    },
    async [ACT_CHAT_ADD_UNSENT_SCH_MESSAGE]({ commit }, payload) {
        const { taskId, time, type, taskPayload } = payload
        // console.log("🚀 ~ chat.js:592 ~ type:", type)
        // console.log("🚀 ~ chat.js:593 ~ taskPayload:", taskPayload)
        const commitPayload = {
            taskId,
            type,
            time,
            status: MSG_STATUSES.MSG_STATUS_SEND_ERROR,
            payload: {
                data: taskPayload.data,
                type: taskPayload.type
            }            
        }
        commit(MUT_CHAT_ADD_UNSENT_SCH_MESSAGE, commitPayload)
        commit(MUT_CHAT_SCH_MESSAGES_SORT)
    },
    async [ACT_CHAT_UPDATE_SCH_MESSAGE]({ dispatch }, params) {
        // console.log("🚀 ~ chat.js:535 ~ ACT_CHAT_UPDATE_SCH_MESSAGE params:", params)
        await dispatch(`${TASKS}/${ACT_TASKS_UPDATE_TASK}`, params, { root: true })
    },
    async [ACT_CHAT_DELETE_SCH_MESSAGE]({ dispatch }, params) {
        try {
            await dispatch(`${TASKS}/${ACT_TASKS_DELETE_TASKS}`, params, { root: true })
        } catch (error) {
            console.log("🚀 ~ chat.js:542 ~ ACT_CHAT_DELETE_SCH_MESSAGE ~ error:", error)
        }
    },
    async [ACT_CHAT_DELETE_UNSENT_SCH_MESSAGE]({ commit }, payload) {
        const { cid, cidType, taskId } = payload
        commit(MUT_CHAT_SCH_MESSAGE_CHANGE, { type: taskChangesType.TASK_DELETE, taskId })
        commit(`${CHATS}/${MUT_DELETE_UNSENT_SCH_MSG_CHAT_DATA}`, { cid, cidType, key: LOCAL_SAVED_DATA_KEYS.SCH_MSGS_UNSENT, taskId }, { root: true })
    },
    async [ACT_CHAT_SCH_MESSAGE_CHANGE]({ commit }, params) {
        commit(MUT_CHAT_SCH_MESSAGE_CHANGE, params)
        commit(MUT_CHAT_SCH_MESSAGES_SORT)
    },
    async [ACT_CHAT_MERGE_UNSENT_MESSAGES]({ rootGetters, dispatch }, { cid, cidType }) {
        const key = 'unsentMessages'
        const savedUnsentMsgs = rootGetters[`${CHATS}/${GET_CHAT_SAVED_DATA}`]({ cid, cidType, key }) || []
        if (!savedUnsentMsgs.length) return
        return savedUnsentMsgs.forEach((message) => {
            if (message.time === null || isNaN(message.time)) return
            const { id, commentId } = message
            let state_msgs = commentId ? state.comments : state.messages
            let old_message = getMessageById(state_msgs, id)
            if (old_message) return
            if (!message.hasOwnProperty('timeDetails')) message.timeDetails = convertTimeMsg(message)
            const updatedTime = convertUnsentMsgTime(message.timeDetails.fullTime)
            if (updatedTime !== message.time) {
                message.time = updatedTime
            }
            if (commentId && message.commentId === commentId || !commentId) dispatch(ACT_CHAT_UPD_MESSAGE, message)
        })
    },
    async [ACT_CHAT_SEARCH_MESSAGES]({}, params) {
        return proto.searchMessages(params)
    }, 
    async [ACT_CHAT_GET_PUBLICATIONS_MEDIA]({}, params) {
        return proto.getPublicationsMedia(params)
    },    
    setUpdating({commit}, isUpdating) {
        commit('setUpdating', isUpdating)
    },
    setChatScrolling({commit}, isScrolling) {
        commit('setScrolling', isScrolling)
    },
    //@todo разобраться и удалить, открывать через chats
    [ACT_OPEN_CHAT]({ state, rootGetters, dispatch, commit }, { cid, cidType = declarations.chatTargetTypes.CHAT_TARGET_TYPE_USER }) {
        dispatch(ACT_CHAT_SHOW_REACTION_PANEL, { isShow: false })
        const mainType = rootGetters[`${CONTENT_MANAGER}/${GET_MAIN_TYPE}`]
        const marked = rootGetters['chats/isMarked']({cid, cidType})
        
        if (CHAT_MAIN_TYPES.includes(mainType) && cidType === state.cidType && cid === state.cid) {
            if (getIsFullCompactMode()) setFullCompactVisibility()
            return
        }
        const isInfoSearch = rootGetters[`${INFO}/${GET_INFO_SHOW_SEARCH}`]
        if (isInfoSearch) dispatch(`${INFO}/${ACT_INFO_SET_SHOW_SEARCH}`, false, { root: true })
        commit('acs/setCid', cid, {root: true})
        dispatch('chats/open', {cid, cidType}, {root: true})
        if (marked) dispatch(`${CHATS}/${ACT_SET_CHAT_MARKED}`, {
            cidType,
            cid,
            marked: false,
        }, {root: true})
    },
    [ACT_CHAT_SCROLL_UP]({commit}, params) {
        commit(MUT_CHAT_SCROLL_UP, params)
    },
    [ACT_THREADS_SCROLL_UP]({commit}, params) {
        commit(MUT_THREADS_SCROLL_UP, params)
    },
    [ACT_CHAT_SET_MSG_ENTITIES]({commit}, msgEntities) {
        commit(MUT_SET_MSG_ENTITIES, msgEntities)
    },
    [ACT_CHAT_UPDATE_EDITED]({commit}, message) {
        if (!message) message = {}
        const groupMsgs = message.groupMsgs
        let { id = 0, isThreads = false, isScheduledMsg = false } = message
        if (groupMsgs && groupMsgs.length > 0) {
            const lastMessage = utils.cloneObject(groupMsgs[groupMsgs.length-1])
            id = lastMessage.msgId
        }
        commit(MUT_SELECTED_MESSAGE, { type: SELECTED_MSG_TYPES.EDITED, id, isThreads, isScheduledMsg })
    },
    [ACT_CHAT_UPDATE_REPLY]({commit}, objParams) {
        let commitParams = {}
        if (objParams) {
            let { id, isThreads = false, quote = '' } = objParams
            commitParams = { type: SELECTED_MSG_TYPES.REPLY, id, isThreads, quote }
        } else commitParams = { type: SELECTED_MSG_TYPES.REPLY, id: 0, isThreads: false, quote: '' }
        commit(MUT_SELECTED_MESSAGE, commitParams)
    },
    async [ACT_CHAT_REMOVE_MSG]({state, commit}, {msg, everyone, isUnsent = false}) {
        if (!isUnsent) {
            await proto.setMessageDeleted(msg.id, everyone)
            if (isSameChat(state, msg)) {
                commit('removeMessage', msg.id)
            }
        } else {
            const { commentId } = msg
            if (commentId) {
                commit(MUT_COMMENT_DELETE, msg)
            } else commit('removeMessage', msg.id)
        }
    },
    async [ACT_CHAT_UPDATE_UNSENT_MESSAGE]({ commit }, payload) {
        commit(MUT_CHAT_UPDATE_UNSENT_MESSAGE, payload)
        const { commentId } = payload
        commit(MUT_CHAT_SORT_MESSAGES, { commentId })
    },
    async [ACT_CHAT_SET_MSG_REACTION]({}, {id, reaction}) {
        await proto.setMessageReaction(id, reaction)
    },
    async [ACT_CHAT_REMOVE_MSGS]({ commit }, {msgs, everyone}) {
        for (let index = 0; index < msgs.length; index++) {
            const msg = msgs[index]
            await proto.setMessageDeleted(msg.msgId, everyone)
            commit('removeMessage', msg.id)
        }
    },
    async [ACT_CHAT_CHANGE_MSG_TEXT]({dispatch, getters}, {id, commentId, text, newEntities = []}) {
        let message = !commentId ? getters[GET_MESSAGE_BY_ID](id) : getters[GET_COMMENT_BY_ID](id)
        if (!message) return
        message = JSON.parse(JSON.stringify(message))
        let { dataType, data } = message
        if (message.type === 'text' || dataType === 'text') data = text
        else if (data) {
            data.text = text
            let { entities = [] } = data
            newEntities.length ? data.entities = newEntities : data.entities = entities
            if (commentId) data.commentId = commentId
            data = JSON.stringify(data)
        } else {
            return
        }
        try {
            await proto.editMessage({id, dataType, data})
            dispatch(ACT_CHAT_UPDATE_EDITED)
        } catch (e) {
            if (e && e.message && e.message === 'dlp-forbidden') {
                dispatch(`${NOTIFICATIONS_NEW}/${ACT_NOTIFY_NEW_ADD}`, {
                    type: NOTIFY_DATA_TYPES.ALERT,
                    payload: {
                        title: locale['dlp-alert-data-forbidden-title'],
                        subtitle: locale['dlp-alert-data-forbidden-message'],
                    }
                }, {root: true})
            }
        }
    },
    async [ACT_CHAT_GET_MESSAGE_BY_ID]({state, getters}, {id, commentId, _cid, _cidType}) {
        let msg = !commentId ? getters[GET_MESSAGE_BY_ID](id) : getters[GET_COMMENT_BY_ID](id)
        let cid, cidType
        if (_cid) cid = _cid
        if (_cidType) cidType = _cidType
        if (!_cid && state.cid) cid = state.cid 
        if (!_cidType && state.cidType) cidType = state.cidType
        if (!msg) {
            try {
                let params = {cid, cidType, id}
                if (commentId) params.commentId = commentId
                msg = await proto.getMessage(params)
            } catch (e) {}
        }
        return msg
    },
    [ACT_SET_CHAT_DRAFT]({ state, dispatch, getters }, payload) {
        // console.log("🚀 ~ chat.js:693 ~ payload:", payload)
        if (!payload) payload = {}
        let { text = '', commentId = 0, isScheduledMsg = false } = payload
        // console.log("🚀 ~ chat.js:696 ~ isScheduledMsg:", isScheduledMsg)
        let { cid, cidType } = state
        let replyId = getters[GET_CHAT_REPLY_MESSAGE_ID](!!commentId)
        // console.log("🚀 ~ chat.js:732 ~ replyId:", replyId)
        let editId = getters[GET_CHAT_EDIT_MESSAGE_ID](!!commentId)
        let draft = {}
        if (text) draft.text = text
        if (replyId) draft.replyId = replyId
        if (editId) draft.editId = editId
        if (commentId && text && (replyId || editId)) draft.commentId = commentId
        if (!Object.keys(draft).length) draft = null
        if (isScheduledMsg) {
            const key = LOCAL_SAVED_DATA_KEYS.SCH_MSGS_DRAFT
            const _payload = { cid, cidType, key }
            _payload[key] = text || ''
            // console.log("🚀 ~ chat.js:710 ~ _payload:", _payload)
            dispatch(`${CHATS}/${ACT_SAVE_CHAT_DATA}`, _payload, { root: true })
            if (!text) Vue.delete(state, 'selectedMsg')
        }
        else dispatch(`${CHATS}/${ACT_SET_CHAT_DRAFT}`, { cid, cidType, draft }, {root: true})
    },
    [ACT_CHAT_SET_SEARCH]({commit}, str) {
        commit(MUT_CHAT_SET_SEARCH, str)
    },
    [ACT_CHAT_SET_MEDIA_SEARCH]({commit}, str) {
        commit(MUT_CHAT_SET_MEDIA_SEARCH, str)
    },
    [ACT_CHAT_ADD_MESSAGE]({commit, dispatch, rootGetters}, payload) {
        const message = payload.message
        commit('addMessage', message)
        if (message.author) {
            let contact = rootGetters[`${CONTACTS}/${GET_MERGED_CONTACT_BY_ID}`](message.author)
            if (!contact || !contact.cid) dispatch(`${CONTACTS}/${ACT_UPDATE_SEARCHED_CONTACT}`, {cid: message.author},  {root: true }).catch()
        }
    },
    [ACT_CHAT_UPDATE_MESSAGE]({ commit, dispatch, getters, rootGetters }, payload) {
        // console.log("🚀🚀 ~ chat.js:658 ~ ACT_CHAT_UPDATE_MESSAGE ~ payload: ", payload)
        const { message, eventMessage, toEnd = true, commentId = 0 } = payload
        const { id } = message
        const chatMessages = getters[GET_CHAT_MESSAGES]
        const chatLastMessage = chatMessages[chatMessages.length - 1]
        const isUpdatingLastMsg = chatLastMessage && id === chatLastMessage.id
        // //console.log("🚀 ~ chat.js:664 ~ isUpdatingLastMsg:", isUpdatingLastMsg)
        let state_msgs = commentId ? state.comments : state.messages
        if (getters[IS_CHAT_NEW_API_SUPPORTED]) {
            if (!isUpdatingLastMsg && eventMessage && !getters[IS_CHAT_HAVE_LAST_MESSAGE]) {
                if (message.type === 'out') {
                    // console.log("🚀🚀 ~ chat.js:724 ~ dispatching ACT_CHAT_GET_SCREEN_MESSAGES ...")
                    dispatch(ACT_CHAT_GET_SCREEN_MESSAGES, payload)
                }
                return
            }
            if (toEnd) {
                while (state_msgs.length + 1 > state.maxMsgs) {
                    state_msgs.shift()
                }
            } else {
                while (state_msgs.length + 1 > state.maxMsgs) {
                    state_msgs.pop()
                }
            }
        }
        commit(MUT_CHAT_UPDATE_MESSAGE, payload)
        if (message.author) {
            let contact = rootGetters[`${CONTACTS}/${GET_MERGED_CONTACT_BY_ID}`](message.author)
            if (!contact || !contact.cid) dispatch(`${CONTACTS}/${ACT_UPDATE_SEARCHED_CONTACT}`, {cid: message.author},  {root: true }).catch()
        }
    },
    [ACT_CHAT_UPD_MESSAGE]({ commit }, message) {
        const { localId } = message
        commit(MUT_CHAT_UPDATE_MESSAGE, { message, localId })
    },
    [ACT_CHAT_UPDATE_REACTION]({commit, rootGetters}, payload) {
        const chat = rootGetters[`${CHATS}/${GET_CHAT}`]({cid: payload.cid, cidType: payload.cidType})
        payload.chat = chat
        commit(MUT_UPDATE_MESSAGE_REACTION, payload)
    },
    [ACT_CHAT_SHOW_REACTION_PANEL]({commit}, payload) {
        commit(MUT_SHOW_REACTION_PANEL, payload)
    },
    [ACT_CHAT_SHOW_REACTION_PICKER]({commit}, payload) {
        commit(MUT_SHOW_REACTION_PICKER, payload)
    },
    [ACT_SET_SELECT_MODE]({commit}, msgIds = []) {
        commit(MUT_SET_SELECT_MODE, msgIds)
    },    
    [ACT_SET_SELECTED_MSGS]({commit}, msgIds = []) {
        commit(MUT_SET_SELECTED_MSGS, msgIds)
    },
    [ACT_DELETE_SELECTED_MSGS]({commit}, msgIds = []) {
        commit(MUT_DELETE_SELECTED_MSGS, msgIds)
    },
    async [ACT_SET_CURRENT_COMMENTS]({commit, getters}, {commentId}) {
        if (commentId !== getters[GET_COMMENT_ID]) {
            commit(MUT_SET_CURRENT_COMMENTS, [])
        }
        commit(MUT_SET_COMMENT_ID, commentId)
    },
    async [ACT_SET_MSG_COMMENT_SUBSCRIBED]({}, payload) {
        let {id, status = false} = payload
        await proto.setMessageCommentSubscribed({id, status})
    },
    [ACT_COMMENT_SUBSCRIBED]({ dispatch, commit }, payload) {
        const { id, status } = payload
        let message = { id, commentsSubscribed: status}
        commit('updateMessageProps', message)
        dispatch(`${INFO}/${ACT_INFO_CHANGE_PARAMS}`, {
            commentId: id,
            isCommentsSubscribed: status
        }, {root: true})
        dispatch(`${NOTIFICATIONS}/${ACT_OPEN_CUSTOM_NOTIFICATION}`, {
            type: 'message',
            title: i18n.t('chat.comments'),
            subtitle: status ? i18n.t('chat.subscribed-on') :  i18n.t('chat.unsubscribed-from'),
            commentId: id,
        }, {root: true})
    },
    async [ACT_COMMENT_SENT_RECEIVED]({getters, rootGetters, dispatch, commit}, payload) {
        payload.isIncrease = true
        const isCommentsSubscribed = payload && payload.commentsSubscribed
        const { commentId, cid, cidType } = payload
        let message = await dispatch(ACT_CHAT_GET_MESSAGE_BY_ID, {id: commentId, _cid: cid, _cidType: cidType })
        const isMsgCommentsSubscribed = message && message.commentsSubscribed
        let ownCid = rootGetters['userdata/getUid']
        let senderId = ('senderId' in payload) ? payload.senderId : ownCid
        let ownMessage = senderId === ownCid
        let isMuted = rootGetters['chats/isMuted']({cid, cidType})
        // @todo костыль для предотвращения нотификаций активных чатов
        try {
            const documentHidden = rootGetters[`${CONTENT_MANAGER}/${GET_DOCUMENT_HIDDEN}`]
            const documentFocus = rootGetters[`${CONTENT_MANAGER}/${GET_DOCUMENT_FOCUS}`]
            if (!isMuted && !documentHidden && documentFocus &&
                state.commentId === commentId && !getters[GET_THREADS_SCROLL_UP]) {
                isMuted = true
            }
        } catch (e) {}
        if (isCommentsSubscribed) {
            if (!isMsgCommentsSubscribed) {
                const params = { id: commentId, status: true }
                dispatch(ACT_SET_MSG_COMMENT_SUBSCRIBED, params)
            }
            if (!ownMessage && !isMuted) dispatch(`${NOTIFICATIONS_NEW}/${ACT_NOTIFY_NEW_ADD}`, { type: NOTIFY_DATA_TYPES.THREADS_MESSAGE, payload }, {root: true})
        }
        commit(MUT_UPDATE_COMMON_MSG_COMMENT_COUNT, payload)
        if (commentId === getters[GET_COMMENT_ID]) commit(MUT_CHAT_UPDATE_MESSAGE, { commentId: payload.commentId, message: payload })
    },
    [ACT_COMMENT_REACTION]({commit}, payload) {
        commit(MUT_UPDATE_MESSAGE_REACTION, payload)
    },
    [ACT_COMMENT_UPDATE]({commit}, payload) {
        commit(MUT_CHAT_UPDATE_MESSAGE, { commentId: payload.commentId, message: payload })
    },
    [ACT_COMMENT_CHANGE]({state, getters, commit}, payload) {
        let { id } = payload
        if (!id) {
            if (payload && payload.settings && payload.settings.draft)
                id = payload.settings.draft.editId
            if (!id) return
        }
        commit('updateMessageProps', payload)
        const isDelete = payload.hasOwnProperty('deletedTime')
        if (isDelete) {
            commit(MUT_COMMENT_DELETE, payload)
            payload.isIncrease = false
            commit(MUT_UPDATE_COMMON_MSG_COMMENT_COUNT, payload)
        }
    },
    async [ACT_CHAT_SEARCH_GLOBAL]({}, payload) {
        return await proto.searchGlobalData(payload)
    },
    async [ACT_JOIN_CHAT_BY_LINK]({}, payload) {
        return await proto.joinChat(payload)
    },
    async [ACT_CHAT_LINK_INFO]({}, payload) {
        try {
            return await proto.chatLinkInfo(payload)
        } catch (error) {
            return { error: true }
        }
    },
    async [ACT_CHAT_LINK_UPDATE]({ commit, rootGetters }, payload) {
        const { cid, cidType, isForcedUpdate = false } = payload
        // console.log("🚀 ~ chat.js:808 ~ payload:", payload)
        const chat = rootGetters[`${CHATS}/${GET_CHAT}`]({ cid, cidType })
        // console.log("🚀 ~ chat.js:820 ~ chat:", chat)
        if (!isForcedUpdate && chat && chat.links && Array.isArray(chat.links)) {
            commit(MUT_CHAT_LINK_UPDATE, { cid, _links: chat.links })
            return chat.links
        }
        const reply = await proto.chatLinkUpdate(payload)
        // console.log("🚀 ~ chat.js:810 ~ reply:", reply)
        let { link } = reply
        // console.log("🚀 ~ chat.js:813 ~ link:", link)
        const links = []
        links.push({ link })
        const params = { cid, _links: links }
        commit(MUT_CHAT_LINK_UPDATE, params)
        return links
    },
    async [ACT_CHAT_LINK_DELETE]({}, payload) {
        // console.log("🚀 ~ chat.js:811 ~ payload:", payload)
        try {
            return await proto.chatLinkRemove(payload)
        } catch (error) {
            console.log("🚀 ~ chat.js:840 ~ error:", error)
            return null
        }
    },
}

const mutations = {
    setUpdating(state, isUpdating) {
        state.isUpdating = isUpdating
    },
    setScrolling(state, isScrolling) {
        state.isScrolling = isScrolling
    },
    setCid(state, cid) {
        state.cid = cid;
    },
    updateCurrentChat(state, params) {
        if (isSameChat(state, params)) return;
        if ("cid" in params) state.cid = params.cid;
        if ("cidType" in params) state.cidType = params.cidType;
    },
    [MUT_CHAT_SORT_MESSAGES](state, {commentId = 0}) {
        let state_msgs = commentId ? state.comments : state.messages
        state_msgs = state_msgs.sort((a, b) => {
            if (isNaN(a.id) || isNaN(b.id) || a.id === b.id) return 0
            if (a.id < b.id) return -1
            if (a.id > b.id) return 1

        })
    },
    [MUT_CHAT_UPDATE_MESSAGE](state, params) {
        // //console.log("🚀 ~ chat.js:815 ~ params:", params)
        try {
            const { message, localId } = params
            const { id, commentId } = message
            let state_msgs = commentId ? state.comments : state.messages
            if (!message.hasOwnProperty('time') || Object.is(message.time, NaN)) {
                message.time = 0
            }
            if (!message.hasOwnProperty('timeDetails')) message.timeDetails = convertTimeMsg(message)
            let old_message = getMessageById(state_msgs, id)
            if (!old_message && localId) {
                if (!id) message.id = localId
                old_message = getMessageById(state_msgs, id)
            }
            if (!old_message) {
                if (isSameChat({ cid: state.cid, cidType: state.cidType }, message)) {
                    state_msgs.push(message)
                }
            } else {
                if (!equals(old_message, message)) {
                    // //console.log("🚀 ~ chat.js:836 ~ old_message:", old_message)
                    // //console.log("🚀 ~ chat.js:837 ~ message:", message)
                    const index = old_message && state_msgs.indexOf(old_message)
                    if(id > 0 && localId) delete message.localId
                    Vue.set(state_msgs, index, Object.assign(old_message, message))
                }
            }
        } catch (error) {
            //console.log("🚀 ~ chat.js:847 ~ error:", error)
            //console.log("🚀 ~ chat.js:848 ~ params:", params)
        }
    },
    [MUT_UPDATE_MESSAGE_REACTION](state, params) {
        const msgId = params.id, commentId = params.commentId, reactionStr = params.reaction || ''
        let state_msgs = commentId ? state.comments : state.messages
        let msg = getMessageById(state_msgs, msgId)
        if (!msg) return
        const cid = params.cid || msg.cid
        const senderId = params.senderId || cid
        let index = state_msgs.findIndex(m => m.id === msgId)
        const reaction = { cid: senderId, reaction: reactionStr, time: 0}
        const reactions = JSON.parse(JSON.stringify(msg.reactions || []))
        const reactionIndex = reactions.findIndex(r => r.cid === senderId)
        if (reactionIndex === -1 && senderId) {
            reactions.unshift(reaction)
        } else if (reactionIndex > -1) {
            reactions.splice(reactionIndex, 1)
            if (reactionStr) {
                reactions.unshift(reaction)
            }
        } else reactions.push(reaction)
        msg.reactions = reactions
        Vue.set(state_msgs, index, Object.assign(msg, msg))
    },
    [MUT_SHOW_REACTION_PANEL](state, params) {
        const { isShow, reactions, aggReactions, style } = params
        state.reactionsPanel.isPanelShow = isShow
        state.reactionsPanel.reactions.reactions = reactions
        state.reactionsPanel.reactions.aggReactions = aggReactions
        if (style) state.reactionsPanel.panelStyle = style
    },
    [MUT_SHOW_REACTION_PICKER](state, params) {
        const { isShow, msgId, style } = params
        state.reactionsPicker.isPickerShow = isShow
        state.reactionsPicker.msgId = msgId
        if (style) state.reactionsPicker.pickerStyle = style
    },
    updateMessageProps(state, message) {
        let message_id = message.id
        let { commentId } = message
        let state_msgs = commentId ? state.comments : state.messages
        let time = convertTimeMsg(message)
        //console.log("🚀 ~ chat.js:870 ~ updateMessageProps ~ time:", time)
        let old_message = getMessageById(state_msgs, message_id)
        //console.log("🚀 ~ chat.js:872 ~ updateMessageProps ~ old_message:", old_message)
        const index = old_message && state_msgs.indexOf(old_message)
        //console.log("🚀 ~ chat.js:874 ~ updateMessageProps ~ index:", index)
        if (old_message) {
            Object.assign(old_message.timeDetails, time)
            //console.log("🚀 ~ chat.js:906 ~ updateMessageProps ~ old_message:", old_message)
        }
        const isDelete = message.hasOwnProperty('deletedTime')
        if (old_message && isDelete) {
            state_msgs.splice(index, 1)
        } else if (old_message) {
            // console.log("🚀 ~ chat.js:912 ~ updateMessageProps ~ old_message:", old_message)
            // console.log("🚀 ~ chat.js:913 ~ updateMessageProps ~ message:", message)
            Vue.set(state_msgs, index, Object.assign(old_message, message))
        }
    },
    [MUT_UPDATE_COMMON_MSG_COMMENT_COUNT](state, params) {
        const { commentId, isIncrease } = params
        const state_msgs = state.messages
        let common_message = getMessageById(state_msgs, commentId)
        if (!common_message) return
        let old_comments_count = +common_message.comments || 0
        let newCommentsCount = isIncrease ?  old_comments_count + 1 : old_comments_count - 1
        Vue.set(common_message, 'comments', newCommentsCount)
    },
    addMessage(state, params) {
        state.messages.push(params);
    },
    removeMessage(state, message_id) {
        const message = getMessageById(state.messages, message_id),
            index = state.messages.indexOf(message);
        if (index !== -1) state.messages.splice(index, 1);
    },
    clearMessages(state, {isComments = false}) {
        const state_msgs = isComments ? state.comments : state.messages
        state_msgs.splice(0, state_msgs.length);
    },
    [MUT_SELECTED_MESSAGE](state, { type, id = null, isThreads = false, quote = '', isScheduledMsg = false}) {
        // console.log("🚀 ~ chat.js:1073 ~ quote:", quote)
        // console.log("🚀 ~ chat.js:1073 ~ isThreads:", isThreads)
        // console.log("🚀 ~ chat.js:1073 ~ type:", type)
        // console.log("🚀 ~ chat.js:1073 ~ id:", id)
        // console.log("🚀 ~ chat.js:1001 ~ isScheduledMsg:", isScheduledMsg)
        let selected = id ? { type, id, isThreads, quote, isScheduledMsg } : null
        Vue.set(state, 'selectedMsg', selected)
    },
    [MUT_SET_MSG_ENTITIES](state, msgEntities = {}) {
        Vue.set(state, 'selectedMsgEntities', msgEntities)
    },
    addPoll(state, obj) {
        state.poll.id = obj.id;
        state.poll.question = obj.question;
        state.poll.answer = obj.answer;
    },
    updatePollVote(state, pollId) {
        state.pollVotes.push(pollId);
    },
    deletePollVote(state, pollId) {
        state.pollVotes.forEach(function(item, i) {
            if(item === pollId) delete state.pollVotes[i];
        });
    },
    [MUT_CHAT_SCROLL_UP](state, params) {
        state.scroll_up = params
    },
    [MUT_THREADS_SCROLL_UP](state, params) {
        state.threads_scroll_up = params
    },
    [MUT_CHAT_SET_SEARCH](state, str) {
        state.chatSearchString = str
    },
    [MUT_CHAT_SET_MEDIA_SEARCH](state, str) {
        state.mediaSearchString = str
    },
    [MUT_SET_SELECT_MODE](state, mode) {
        state.isSelectMode = mode
    },
    [MUT_SET_SELECTED_MSGS](state, msgIds) {
        state.selectedMessages = msgIds
    },
    [MUT_DELETE_SELECTED_MSGS](state, msgIds) {
        msgIds.forEach(m => {
            const index = state.selectedMessages.indexOf(m)
            if (index > -1) state.selectedMessages.splice(index, 1)
        })
    },
    [MUT_SET_CURRENT_COMMENTS](state, comments) {
        state.comments = comments
    },
    [MUT_SET_COMMENT_ID](state, commentId) {
        state.commentId = commentId
    },
    [MUT_COMMENT_DELETE](state, comment) {
        const { id } = comment
        const _comment = getMessageById(state.comments, id)
        const index = state.comments.indexOf(_comment)
        if (index > -1) state.comments.splice(index, 1)
    },
    [MUT_CHAT_UPDATE_UNSENT_MESSAGE](state, payload) {
        // //console.log("🚀 ~ chat.js:980 ~ MUT_CHAT_UPDATE_UNSENT_MESSAGE:", payload)
        const { id, localId, commentId } = payload
        const state_msgs = commentId ? state.comments : state.messages
        const message = getMessageById(state_msgs, localId)
        if (!message) return
        if (id && id > 0) {
            const index = state_msgs.indexOf(message)
            message.id = id
            message.status = MSG_STATUSES.MSG_STATUS_SEND_OK
            message.time = 0
            message.timeDetails = convertTimeMsg(message)
            Vue.set(state_msgs, index, message)
        }
    },
    [MUT_CHAT_LINK_UPDATE](state, params) {
        const { cid, _links } = params
        if (!cid) return
        let links = _links && _links.length ? _links : []
        if (!state.groupChatLinks[cid]) state.groupChatLinks[cid] = []
        Vue.set(state.groupChatLinks, cid, links)
    },
    [MUT_CHAT_SCH_MESSAGES_SORT](state) {
        state.schMessages = state.schMessages.sort((a, b) => {
            if (isNaN(a.time) || isNaN(b.time) || a.time === b.time) return 0
            if (a.time < b.time) return -1
            if (a.time > b.time) return 1
        })
    },
    [MUT_CHAT_SCH_MESSAGES](state, payload) {
        state.schMessages = payload
    },
    [MUT_CHAT_ADD_UNSENT_SCH_MESSAGE](state, unsentSchMsg) {
        state.schMessages.push(unsentSchMsg)
    },
    [MUT_CHAT_SCH_MESSAGE_CHANGE](state, payload) {
        // console.log("🚀 ~ chat.js:1054 ~ MUT_CHAT_SCH_MESSAGE_CHANGE payload:", payload)
        let { type, task, taskId, payload: _payload = {} } = payload
        // console.log("🚀 ~ chat.js:1220 ~ taskId:", taskId)
        const tasks = state.schMessages
        // console.log("🚀 ~ chat.js:1222 ~ tasks:", tasks)
        let old_task, index
        switch (type) {
            case taskChangesType.TASK_ADD:
                // console.log("🚀 ~ chat.js:1225 ~ _payload:", _payload)
                // const { data = {} } = _payload
                // const { localId = 0 } = data
                // console.log("🚀 ~ chat.js:1228 ~ localId:", localId)
                let _taskId = task.taskId
                old_task = tasks.find(t => t.taskId === _taskId)
                if (!old_task) tasks.push(task)
                break
            case taskChangesType.TASK_UPDATE:
            case taskChangesType.TASK_CHANGE:
                if (!taskId && task) taskId = task.taskId || 0
                if (!taskId) break
                index = tasks.findIndex(t => t.taskId === taskId)
                old_task = index > -1 ? tasks[index] : null
                if (old_task) Vue.set(tasks, index, Object.assign(old_task, task))
                break
            case taskChangesType.TASK_DELETE:
                old_task = tasks.find(t => t.taskId === taskId)
                index = old_task && tasks.indexOf(old_task)
                if (old_task && index !== -1) tasks.splice(index, 1)
                break
            default:
                break
        }
    },
}

function getSystemText ({ rootGetters }, data) {
    let editor
    let target
    let text
    switch (data.type) {
        case declarations.msgSystemTypes.MSG_SYSTEM_TYPE_CHAT_CREATED:
            editor = getChatEditor({ rootGetters }, data.cid)
            text = editor.fio + ' ' + locale['created-chat']
            break
        case declarations.msgSystemTypes.MSG_SYSTEM_TYPE_CHAT_ADDED:
            editor = getChatEditor({ rootGetters }, data.editorId)
            if (data.editorId && data.editorId < 0) {
                const contact = rootGetters[`${CONTACTS}/${GET_MERGED_CONTACT_BY_ID}`](data.cid)
                text = contact.fio + i18n.t('being-joined')
            } else {
                target = rootGetters[`${CONTACTS}/${GET_MERGED_CONTACT_BY_ID}`](data.cid)
                text = editor.fio + locale.added + target.fio
            }
            break
        case declarations.msgSystemTypes.MSG_SYSTEM_TYPE_CHAT_CHANGED:
            editor = getChatEditor({ rootGetters }, data.editorId)
            target = rootGetters[`${CONTACTS}/${GET_MERGED_CONTACT_BY_ID}`](data.cid)
            text = editor.fio + i18n.t('chat.group-chat.user-rights-changed') + target.fio
            break
        case declarations.msgSystemTypes.MSG_SYSTEM_TYPE_CHAT_DELETED:
            editor = 'editorId' in data && getChatEditor({ rootGetters }, data.editorId)
            if (data.editorId && data.editorId < 0) {
                const contact = rootGetters[`${CONTACTS}/${GET_MERGED_CONTACT_BY_ID}`](data.cid)
                text = contact.fio + i18n.t('being-removed')
            } else {
                target = rootGetters[`${CONTACTS}/${GET_MERGED_CONTACT_BY_ID}`](data.cid)
                text = (editor ? editor.fio + i18n.t('removed') + target.fio : target.fio + locale.left)
            }
            break
        case declarations.msgSystemTypes.MSG_SYSTEM_TYPE_CHAT_UPDATED:
            editor = getChatEditor({ rootGetters }, data.cid)
            if ('title' in data && data.title) {
                text = editor.fio + i18n.t('chat.group-chat.changed-group-name')
            }
            if ('icon' in data && typeof data.icon === 'string') {
                text = editor.fio + i18n.t('chat.group-chat.update-group-photo')
            }
            if ('pinMessage' in data && data.pinMessage > 0) {
                text = editor.fio + locale['s1-pinned-msg']
            }
            if ('pinMessage' in data && data.pinMessage === 0) {
                text = editor.fio + locale['unpinned-msg']
            }
            if ('readOnly' in data) {
                text = i18n.t(data.readOnly ? 'read-only-on-msg' : 'read-only-off-msg', {name: editor.fio})
            }
            if (!text) text = i18n.t('default-change-msg', {name: editor.fio})
            break
        default:
            text = locale['unknown-sys-msg']
    }
    return text
}

function getChatEditor({ rootGetters }, editorCid) {
    if (editorCid === 0) {
        return { fio: i18n.t('system-administrator') }
    } else {
        return rootGetters[`${CONTACTS}/${GET_MERGED_CONTACT_BY_ID}`](editorCid)
    }
}

function getDataText ({ rootGetters }, _data) {
    let text, data
    if (!_data.hasOwnProperty('type')) {
        data = JSON.parse(_data)
    } else data = _data
    switch (data.type) {
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CONTACT:
            if (data.cid) {
                let contact = rootGetters[`${CONTACTS}/${GET_MERGED_CONTACT_BY_ID}`](data.cid)
                if (contact) {
                    text = {
                        cid: data.cid,
                        fio: contact.fio,
                        photo: contact.photo,
                    }
                    if (data.file) text = {...text, file: declarations.http_post_dirs.CHAT_DATA_DIR + data.file}
                }
            } else {
                const fields = Array.isArray(data.fields) && data.fields
                const phones = fields && fields.filter(f => f.type === CONTACT_FIELD_TYPES.PHONE || f.type === CONTACT_FIELD_TYPES.WORKPHONE)
                const phone = phones && phones.length && phones[0].value
                const mails = fields && fields.filter(f => f.type === CONTACT_FIELD_TYPES.MAIL)
                const mail = mails && mails.length && mails[0].value
                const fio = (fields && fields.fio) || phone || mail
                text = {
                    fio,
                    file: declarations.http_post_dirs.CHAT_DATA_DIR + data.file,
                }
            }

            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CHANNEL:
            text = data
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_PUBLICATION:
            text = {
                chId: data.chId,
                pubId: data.pubId,
                text: data.text,
            }
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_LOCATION:
            text = {
                location_link_url: app.getLocationLinkUrl(data),
                location_image_url: app.getLocationImageUrl(data),
                longitude: data.longitude,
                latitude: data.latitude,
            }
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_IMAGE:
            text = {
                size: data.size,
                extension: data.extension,
                file: declarations.http_post_dirs.CHAT_DATA_DIR + data.file,
                preview: data.preview,
                name: data.name,
                text: data.text,
                previewFile: data.previewFile,
                previewSize: data.previewSize,
            }
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_VIDEO:
            text = {
                size: data.size,
                extension: data.extension,
                duration: data.duration,
                file: declarations.http_post_dirs.CHAT_DATA_DIR + data.file,
                preview: data.preview,
                name: data.name,
                text: data.text,
                previewFile: data.previewFile,
                previewSize: data.previewSize,
            }
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_AUDIO:
            text = {
                size: data.size,
                extension: data.extension,
                duration: data.duration,
                file: declarations.http_post_dirs.CHAT_DATA_DIR + data.file,
                name: data.name,
                text: data.text,
            }
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_FILE:
            text = {
                size: data.size,
                extension: data.extension,
                file: declarations.http_post_dirs.CHAT_DATA_DIR + data.file,
                name: data.name,
                text: data.text,
                readOnly: data.readOnly,
                key: data.key,
            }
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_POLL:
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CALL_AVAILABILITY:
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_SURVEY:
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_SCHEDULE:
            text = data
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_TEXT:
            text = data.text
            break
        default:
            text = locale['unknown-msg-type']
    }
    return text
}

function getListDataText(data) {
    let text
    switch (data.type) {
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CONTACT:
            text = locale.modal['sent-contact']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CHANNEL:
            text = locale.modal['sent-channel']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_PUBLICATION:
            text = locale.modal['sent-post']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_LOCATION:
            text = locale.modal['sent-geo']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_IMAGE:
            text = locale.modal['sent-img']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_VIDEO:
            text = locale.modal['sent-video']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_AUDIO:
            text = locale.modal['sent-audio']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_FILE:
            text = locale.modal['sent-file']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_POLL:
            text = locale.modal['sent-poll']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CALL_AVAILABILITY:
            text = locale.modal['sent-call-availability']
            break
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_SURVEY:
            text = locale.chat['survey']
            break  
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_SCHEDULE:
            text = locale.chat['schedule']
            if (data.eventType === 'invite') text += ': ' + locale.chat['schedule-names'].invite
            else text += ': ' + locale.chat['schedule-names']['appointment-start']
            break                    
        case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_TEXT:
            text = data.text
            break
        default:
            text = locale['unknown-msg-type']
    }
    return text
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
